module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ar":{"desc":"Enter your investor number to check if you have any DFM PJSC unclaimed dividends.","formlabel":{"captcha":"كلمة التحقق","nin":"NIN","securitycode":"الرجاء ادخال الحروف الظاهرة في الصورة:"}}}')
  delete Component.options._Ctor
}
